<div class="skeleton-loading" [ngClass]="hostClasses"></div>
